import Rating from './Rating';

export { Rating };
